module.exports = __webpack_public_path__ + "static/media/rco-requirement.b28ba107.svg";